import React from 'react'
import { Link } from 'react-router-dom';
import app_store from '../../../assets/images/icon/appstore-badge.png'
import playstore from '../../../assets/images/icon/googleplay-badge.png'
// import Qr_code from '../../../assets/images/qr/app-download-qr.png'
import Qr_code from '../../../assets/images/qr/goneet.png'
import './footer.css'

const Footer = () => {
    return (
        <div>
            <footer>
                <div className="container">
                    <div className="row bottom-border">
                        <div className="col-lg-3 col-12 d-none d-md-block">
                            <div className="footer-logo">
                                <Link to="/">
                                    <img src="/assets/images/logo-white.svg" alt="neet" />
                                </Link>
                            </div>
                        </div>

                        <div className="col-lg-9 col-12">
                            <div className="row footer-menu">
                                <div className="col-12">
                                    <ul>
                                        <li><Link to="/user/profile">MY Profile</Link></li>
                                        <li>
                                            <Link to="/user/profile-analytics">
                                                goneet <span><b style={{ backgroundColor: 'white', color: 'black', padding: '4px', borderRadius: '4px' }}>PRO</b></span>
                                            </Link>
                                        </li>
                                        <li><Link to="/user/network">MY Network</Link></li>
                                        <li><Link to="/user/performance">MY Performance</Link></li>
                                        <li><a href="/how-it-works.pdf" target="_blank" rel="noopener noreferrer">How it works</a></li>
                                        <li><Link to="/contact#top">Contact</Link></li>
                                    </ul>
                                </div>
                                <div className="col-12">
                                    <ul className="privacy-menu">
                                        <li><Link to="/cookies-policy#top">Cookies</Link></li>
                                        <li><Link to="/terms-of-service#top">Terms of Service</Link></li>
                                        <li><Link to="/privacy-policy#top">Privacy Policy</Link></li>
                                        <li><Link to="/cancellation-refund-policy#top">Cancellation / Refund Policy</Link></li>

                                    </ul>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row middle-section align-items-center">
                        <div className="col-md-6 col-12">
                            <div className="social-links d-flex align-items-center">
                                <ul className="d-flex align-items-center" style={{ gap: '10px', marginBottom: 0 }}>
                                    <li><img src="/assets/images/icons/icons8-twitter-30.png" alt="twitter" /></li>
                                    <li>
                                        <Link to="/">
                                            <img
                                                src="/assets/images/icons/icons8-linkedin-50.png"
                                                alt="linkedin"
                                                style={{ height: '32px', width: 'auto' }}
                                            />
                                        </Link>
                                    </li>
                                    <li style={{ marginLeft: '20px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <div className="app-buttons d-flex" style={{ gap: '10px', marginLeft: '20px' }}>
                                            <a href="https://apps.apple.com/ie/app/goneet-app/id6755640711" target="_blank" rel="noopener noreferrer">
                                                <img
                                                    src={app_store}
                                                    alt="Download on the App Store"
                                                    style={{ height: '35px', width: 'auto',}}
                                                />
                                            </a>
                                            <a href="https://play.google.com/store/apps/details?id=com.goneet_app&pcampaignid=web_share" target="_blank" rel="noopener noreferrer">
                                                <img
                                                    src={playstore}
                                                    alt="Get it on Google Play"
                                                    // style={{ height: '40px', width: 'auto' }}
                                                    style={{ height: '35px', width: 'auto' , }}
                                                />
                                            </a>
                                        </div>
                                    </li>

                                    
                                    {/* QR Code + App Links */}
                                    <li  className="qr-code-container" style={{ marginLeft: '20px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <div style={{ textAlign: 'center' }}>
                                        <img
                                        src={Qr_code} // <-- your QR image path
                                        alt="Download QR"
                                        style={{
                                            width: '60px',
                                            height: '60px',
                                            borderRadius: '8px',
                                            border: '1px solid #ccc'
                                        }}
                                        />
                                        <p style={{ fontSize: '12px', marginTop: '4px', color: '#999' }}>Scan to download</p>
                                    </div>

                                    
                                    </li>
                                </ul>

                            
                            </div>
                        </div>

                        <div className="col-md-6 col-12 text-center text-lg-right mt-3 mt-md-0">
                            <div className="copyright-content">
                                <span>© goneet 2024</span>
                                <span style={{ marginLeft: '10px' }}>© goneet Profile</span>
                                <span style={{ marginLeft: '20px' }}>All rights reserved</span>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    )
}

export default Footer;
